<template>
  <div
    class="status"
  >
    <overlay
      :is-loading="isLoading"
    />
    <users-count
      :count="usersCount"
      :is-playing="isPlaying"
    />
    <v-chip
      color="#C4C4C4"
      size="small"
      class="text-uppercase"
      :class="chipTextColor"
    >
      {{ chipText }}
    </v-chip>
    <v-btn
      v-if="gameWeek.isOpen()"
      :color="buttonColor"
      :loading="isLoadingButton"
      :disabled="disabled"
      @click="buttonClick"
    >
      {{ buttonText }}
      <font-awesome-icon
        :icon="['fas', buttonIcon]"
        size="sm"
        class="ml-2"
      />
    </v-btn>
  </div>
</template>

<script>
import Overlay from '@/components/Overlay.vue';
import UsersCount from '@/components/UsersCount.vue';
import GameWeek from '@/models/GameWeek/gameWeek';

export default {
  name: 'Status',
  components: {
    Overlay,
    UsersCount,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    statusConfirmed: {
      type: Boolean,
      default: false,
    },
    shouldConfirm: {
      type: Boolean,
      default: true,
    },
    usersCount: {
      type: Number,
      default: 0,
    },
    isPlaying: {
      type: Boolean,
      default: false,
    },
    gameWeek: {
      type: GameWeek,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chipTextColor() {
      return this.statusConfirmed ? 'tex-black' : 'text-error';
    },
    chipText() {
      return this.statusConfirmed ? this.$t('status.confirmed') : this.$t('status.not_confirmed');
    },
    buttonText() {

      return this.shouldConfirm ? this.$t('status.confirm') : this.$t('status.cancel');
    },
    buttonIcon() {
      return this.shouldConfirm ? 'check' : 'trash';
    },
    buttonColor() {
      return this.shouldConfirm ? 'primary' : 'error';
    },
  },
  methods: {
    buttonClick() {
      return this.shouldConfirm ? this.$emit('confirm') : this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="scss">
.status {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  max-width: 1200px;
}

.status-button {
  position: absolute;
  right: 15px;
  top: 34px;
  text-align: right;
  width: 180px;
}
</style>
